import TodoList from "./TodoList";
import Footer from "./Footer";
import "./App.css";

function App() {
  return (
    <div className="App">
      <TodoList />
      <Footer />
    </div>
  );
}

export default App;
